import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements OnInit {
  @Input() tabs: any[];
  @Output() tabClicked = new EventEmitter<any>();
  constructor() {}

  ngOnInit(): void {}
  onClick(tab: any) {
    this.tabs.forEach(t => {
      t.current = t === tab;
    });
    this.tabClicked.emit(tab);
  }
}
